import { metrics } from '@atlassian/browser-metrics/factory';
import type { Metric } from '@atlassian/browser-metrics/metric';

import type { ChatModeParams } from './ChatModeParams';
import { getMessageMetricsNameWithParams } from './getMessageMetricsNameWithParams';

const SEND_MESSAGE_METRICS_KEY = 'ai-mate.send-message';

const TIME_TO_FIRST_ANSWER_PART_METRICS_KEY = 'ai-mate.time-to-first-answer-part';

const TIME_TO_FIRST_ACTION_PART_METRICS_KEY = 'ai-mate.time-to-first-action-part';

const TIME_TO_ACTION_COMPLETION_METRICS_KEY = 'ai-mate.time-to-action-completion';

export const messageLatencyMetrics = {
	createSendMessageMetrics: (params: ChatModeParams): Metric => {
		return metrics.interaction({
			key: getMessageMetricsNameWithParams(SEND_MESSAGE_METRICS_KEY, params),
		});
	},
	createTimeToFirstAnswerPartMetrics: (params: ChatModeParams): Metric => {
		return metrics.interaction({
			key: getMessageMetricsNameWithParams(TIME_TO_FIRST_ANSWER_PART_METRICS_KEY, params),
		});
	},
	createTimeToFirstActionPartMetrics: (params: ChatModeParams): Metric => {
		return metrics.interaction({
			key: getMessageMetricsNameWithParams(TIME_TO_FIRST_ACTION_PART_METRICS_KEY, params),
		});
	},
	createTimeToActionCompletionMetrics: (params: ChatModeParams): Metric => {
		return metrics.interaction({
			key: getMessageMetricsNameWithParams(TIME_TO_ACTION_COMPLETION_METRICS_KEY, params),
		});
	},
};
